import { render, staticRenderFns } from "./BookingDialogStepProduct2.vue?vue&type=template&id=54c1a4d2&scoped=true&"
import script from "./BookingDialogStepProduct2.vue?vue&type=script&lang=js&"
export * from "./BookingDialogStepProduct2.vue?vue&type=script&lang=js&"
import style0 from "./BookingDialogStepProduct2.vue?vue&type=style&index=0&id=54c1a4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1a4d2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorsProductV2: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ColorsProductV2.vue').default})
